<template>
  <div class="camp-card">
    <div class="camp-card__img">
      <CardImg url="https://img01.yzcdn.cn/vant/cat.jpeg" campNum="15" />
    </div>
    <div class="camp-card__main">
      <CardTitle title="【第33期】港股打新行动营" />
      <CardMinorTitle title="手把手带你实操赚钱，轻松月入几千" />
      <div class="card__main__btm">
        <div class="beg-date" v-if="mode === 0">07月10日开营</div>

        <template v-if="mode === 1">
          <MoneyTag :amount="99" />
          <div class="people-num">3745人在学</div>
        </template>
      </div>
      <div class="seckill-tips" v-if="mode === 0">
        <div class="seckill-tips__text">限时秒杀</div>
        <div class="divider"></div>
        <MoneyTag :amount="11" color="#fff" />
      </div>
    </div>
  </div>
</template>

<script>
import CardImg from './CardImg.vue';
import CardTitle from './CardTitle.vue';
import CardMinorTitle from './CardMinorTitle.vue';
import MoneyTag from './MoneyTag.vue';

export default {
  components: {
    CardImg,
    CardTitle,
    CardMinorTitle,
    MoneyTag,
  },
  props: {
    mode: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="stylus" scoped>
.camp-card {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 0.5px solid #f2f2f2;

  .camp-card__img {
    width: 80px;
    height: 100px;
  }

  .camp-card__main {
    position: relative;
    flex: 1;
    max-width: calc(100% - 80px - 12px);

    .card__main__btm {
      position: absolute;
      bottom: 2px;
      left: 0;
      display: flex;
      align-items: flex-end;
    }
  }
}

.beg-date {
  font-size: 12px;
  color: #999;
}

/deep/ .money-tag {
  color: #FC5244;
}

.people-num {
  margin-left: 8px;
  font-size: 11px;
  color: #999;
}

.seckill-tips {
  position absolute
  bottom 2px
  right 0
  display flex
  align-items center
  padding 0 8px
  height: 24px;
  background: linear-gradient(90deg, #FF6C01 0%, #FF154F 100%);
  border-radius: 4px;

  .seckill-tips__text {
    font-size 12px
    font-weight 500
    color #fff
  }

  .divider {
    margin 0 8px
    width 1px
    height 12px
    background rgba(255, 255, 255, 0.4)
    border-radius .5px
  }
}
</style>
